export enum CatalogType {
  Category = 'category',
  Collection = 'collection',
}
